import {injectable} from "inversify";
import {PlayerType} from "@game/coregame/interfaces/PlayerType";
import {Fighter} from "@game/coregame/ecs/entities/Fighter";
import {math} from "@game/coregame/helpers";
@injectable()
export class PCell {
    static readonly SIZE = 100;
    private readonly _owners: PlayerType[] = [];
    private readonly _fighters: Set<Fighter> = new Set();

    public add(fighter: Fighter) {
        this._owners.indexOf(fighter.owner) == -1 && this._owners.push(fighter.owner);
        this._fighters.add(fighter);
    }

    public getCollisions(): [Fighter, Fighter][] {
        if (this._owners.length < 2) {
            return [];
        }
        const collisions: [Fighter, Fighter][] = [];
        loop1: for (const a of this._fighters) {
            for (const b of this._fighters) {
                if (a.owner !== b.owner) {
                    if (math.dist(a.position, b.position) < Fighter.DEFAULT_SIZE * 2) {
                        this._fighters.delete(a);
                        collisions.push([a, b]);
                        continue loop1;
                    }
                }
            }
        }
        this._owners.splice(0, this._owners.length); // clear array
        this._fighters.clear();

        return collisions;
    }
}
